import { render, staticRenderFns } from "./DeletedBookingIcon.vue?vue&type=template&id=6ace3da6"
import script from "./DeletedBookingIcon.vue?vue&type=script&lang=js"
export * from "./DeletedBookingIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports